// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SucessPage_successContainer__2rW-x {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  min-height: 450px;
}

.SucessPage_successIcon__Ehq2n {
  color: #34d399;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
}

.SucessPage_successTitle__TGsRu {
  font-size: 2.25rem;
  font-weight: 700;
  color: var(--primary-dark-blue);
  margin-bottom: 16px;
}

.SucessPage_successMessage__g-N6U {
  font-size: 1.125rem;
  color: #555;
  max-width: 500px;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuccessPage/SucessPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".successContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  min-height: 450px;\n}\n\n.successIcon {\n  color: #34d399;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 24px;\n}\n\n.successTitle {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  margin-bottom: 16px;\n}\n\n.successMessage {\n  font-size: 1.125rem;\n  color: #555;\n  max-width: 500px;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successContainer": `SucessPage_successContainer__2rW-x`,
	"successIcon": `SucessPage_successIcon__Ehq2n`,
	"successTitle": `SucessPage_successTitle__TGsRu`,
	"successMessage": `SucessPage_successMessage__g-N6U`
};
export default ___CSS_LOADER_EXPORT___;
